import React from 'react';
import { Navbar, Container, Nav } from 'react-bootstrap';

import logo from '../img/logo.PNG';

function NavbarComponent() {
  return (
    <Navbar bg="light" expand="md" className="py-3 shadow-sm border-bottom">
      <Container>

        {/* Brand: logo + titolo */}
        <Navbar.Brand href="/" className="d-flex align-items-center">
          <img
            src={logo}
            alt="Logo"
            width="45"
            height="45"
            className="d-inline-block me-2"
          />
          <span className="fw-semibold fs-5 text-dark">
            Gestione Costi R&D - PUL
          </span>
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="navbar-content" />

        <Navbar.Collapse id="navbar-content" className="justify-content-end">
          <Nav className="align-items-center">
            <Nav.Link href="/" className="px-3 text-dark">
              Home
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>

      </Container>
    </Navbar>
  );
}

export default NavbarComponent;
